
export const DateComparator = (valueA, valueB) => {
  const parseDate = (val) => {
    if (!val || val === "NA" || val === "-") return null;

    let str = val;

    // Handle if val is HTML element (unlikely, but defensive)
    if (typeof val === "object" && val?.innerText) {
      str = val.innerText;
    }

    // If string contains underline tag or other tags, strip them
    str = str.replace(/<[^>]*>/g, "").trim();

    // Convert from "08-May-2025 10:31:07" to Date
    const date = new Date(str.replace(/-/g, "/")); // safer parsing
    return isNaN(date) ? null : date;
  };

  const dateA = parseDate(valueA);
  const dateB = parseDate(valueB);

  if (!dateA && !dateB) return 0;
  if (!dateA) return 1;
  if (!dateB) return -1;

  return dateA - dateB;
};
